export const buildGroupPermissions = (user) => {
    const groupPermissions = user === null || user === void 0 ? void 0 : user.flattened_user_group_user_permissions;
    if (!groupPermissions || (groupPermissions === null || groupPermissions === void 0 ? void 0 : groupPermissions.length) === 0) {
        return new Map();
    }
    const groupPermissionsMap = new Map();
    groupPermissions.forEach((groupPermission) => {
        var _a;
        const { user_group_id: groupId, permission_id: permissionName } = groupPermission;
        if (groupPermissionsMap.get(groupId)) {
            (_a = groupPermissionsMap.get(groupId)) === null || _a === void 0 ? void 0 : _a.add(permissionName);
        }
        else {
            groupPermissionsMap.set(groupId, new Set([permissionName]));
        }
    });
    return groupPermissionsMap;
};
export const buildPermissions = (user) => {
    const group = buildGroupPermissions(user);
    return { group };
};
export const getPermissionsForGroup = (groupId, groupPermissions) => {
    return new Set((groupPermissions === null || groupPermissions === void 0 ? void 0 : groupPermissions.get(groupId)) || []);
};
//# sourceMappingURL=utils.js.map